import { FC } from 'react';
import styles from '../styles.module.css';
import { GCoinIcon } from '../icons/GCoinIcon';

interface ConversionCardProps {
  conversion: {
    id: string;
    fromAmount: number;
    fromCurrency: string;
    toAmount: number;
    paymentLink?: string;
  };
  isLastCard: boolean;
  currencyType: "PYL" | "G_COIN";
  onButtonClick: (paymentLink: string) => void;
  getButtonStyle: (currency: string, isLast: boolean) => React.CSSProperties;
}

export const ConversionCard: FC<ConversionCardProps> = ({
  conversion,
  isLastCard,
  currencyType,
  onButtonClick,
  getButtonStyle
}) => {
  return (
    <div className={styles.containers}>
      <div className={styles.conversionCard}>
        <img
          src={`/Cash/${currencyType === "PYL" ? "Pyl.svg" : "usd.svg"}`}
          alt={conversion.fromCurrency}
          className={styles.currencyIcon}
          style={isLastCard ? { opacity: 0.5 } : {}}
        />
        <div className={styles.priceContainer}>
          <span className={styles.price}>{conversion.toAmount}</span>
        </div>
        {isLastCard && <div className={styles.greyOverlay}></div>}
      </div>
      <button 
        className={styles.buyButton}
        style={getButtonStyle(conversion.fromCurrency, isLastCard)}
        disabled={isLastCard}
        onClick={() => onButtonClick(conversion.paymentLink || "")}
      >
        PURCHASE {conversion.fromAmount}{" "}
        {conversion.fromCurrency === "G_COIN" ? (
          <GCoinIcon isLastCard={isLastCard} />
        ) : (
          <span className={styles.dollarSign} style={isLastCard ? { opacity: 0.5 } : {}}>$</span>
        )}
      </button>
    </div>
  );
}; 